var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[(_vm.loadingPage)?_c('span',[_vm._v(_vm._s(_vm.__('loading')))]):_vm._e(),_vm._t("default",null,null,_vm.items)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }